/**
 * ColumnDragOverlay — Floating preview of column header during drag.
 *
 * Renders inside @dnd-kit's DragOverlay component to follow the cursor.
 * Styled with elevation (shadow) and slight scale for a "lifted" feel.
 */

import { cx } from '@/utils/cx';

import { styles } from '../styles';

export interface ColumnDragOverlayProps {
  /** Column header label */
  label: string;
  /** Column width in pixels */
  width: number;
  /** Table size variant */
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Floating column header preview shown during drag-to-reorder.
 * Designed to match ResizableHeader appearance with added visual emphasis.
 */
export function ColumnDragOverlay({
  label,
  width,
  size = 'md',
}: ColumnDragOverlayProps) {
  return (
    <div
      style={{ width }}
      className={cx(
        styles.common.headerCell,
        styles.sizes[size].headerCell,
        // Elevation and visual emphasis
        'shadow-lg opacity-95 pointer-events-none',
        // Subtle lift for dynamism
        'scale-[1.02]',
        // Solid background (no transparency)
        'bg-[var(--color-bg-secondary)]'
      )}
    >
      <span className='truncate font-medium text-[var(--color-text-primary)]'>
        {label}
      </span>
    </div>
  );
}
